module.exports = __webpack_public_path__ + "static/img/works.490c228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/works.png
// module id = 381B
// module chunks = 0